/* istanbul ignore file */

import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { colors, spacing } = themeVariables;

const THUMBNAIL_SIZE = 90;

export const root = css`
  margin: 0;
  overflow-x: auto;
  overflow-y: hidden;
`;

export const thumbnailsWithKeyboardFocus = css`
  border-radius: 14px;
  box-shadow: 0 0 0 3px var(--neutral-white-base), 0 0 0 5px var(--brand-purple-base);
`;

export const list = css`
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
  gap: var(${spacing.sm});

  /*
   * justify-content: center on a scrollable flex container makes the start of the
   * content unreachable once it overflows (the browser won't let you scroll into the
   * space centering pushed it into). These auto-margin spacers achieve the same visual
   * centering when everything fits, but collapse to 0 once the thumbnails overflow,
   * so the first thumbnail stays reachable.
   */
  &::before,
  &::after {
    margin: auto;
    content: '';
  }
`;

export const listItem = css`
  flex-shrink: 0;
  flex-basis: ${THUMBNAIL_SIZE}px;
`;

export const image = css`
  border-radius: 6px;
  display: block;
  width: 100%;
`;

export const imageButton = css`
  display: block;
  padding: 0;
  opacity: 0.4;
  position: relative;
  border: none;
  background: none;
  cursor: pointer;
  width: 100%;
  border: 2px solid transparent;
  width: ${THUMBNAIL_SIZE}px;
  height: ${THUMBNAIL_SIZE}px;

  .js-focus-visible &.focus-visible {
    border-color: var(${colors.stroke.selected});
  }

  &[aria-selected='true'] {
    opacity: 1;
    border-color: var(${colors.stroke.selected});
    border-radius: 8px;
  }
`;

export const videoThumbnail = css`
  position: absolute;
  inset: 0;
  display: block;
`;

export const videoPoster = css`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
`;

export const playIcon = css`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  background-color: rgb(0 0 0 / 60%);
  color: #fff;
  font-size: 10px;
  line-height: 1;
`;
